module.exports = __webpack_public_path__ + "media/KikiCB.482092bb.mp3";